import AbstractRepository from "@/repositories/AbstractRepository";
import Http from "front-component/Http";

export default class NotificationMessageRepository extends AbstractRepository {
    protected static resource: string = "notification-message";

    protected static defaultFields: string[] = [
        "uuid",
        "subject",
        "body",
        "link",
        "type",
        "seenAt",
        "deletedAt",
        "createdAt",
    ];

    public static deleteAll(seenOnly: boolean): Promise<boolean> {
        return new Promise((resolve, reject) => {
            const params: { seenOnly?: boolean } = {};
            if (seenOnly) {
              params.seenOnly = true;
            }
            Http
                .get(
                    `/${this.resource}/delete-all`,
                    params,
                    () => {
                        resolve();
                    },
                    () => {
                        reject();
                    }
                )
            ;
        });
    }

    public static seenAll(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            Http
                .get(
                    `/${this.resource}/seen-all`,
                    {},
                    () => {
                        resolve();
                    },
                    () => {
                        reject();
                    }
                )
            ;
        });
    }
}
